import React, { Component } from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
import CheckLoginStatus from '../conditions/CheckLoginStatus'
import Grid from '../components/Grid'
import styled from 'styled-components'

const PlaylistLink = styled.a`
  display: flex;
  background: var(--${props => props.disabled ? 'gray' : props.color});
  color: #fff;
  padding: 0.75rem 1.25rem;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  transition: all 0.2s;
  font-weight: 300;
  border-radius: 1.25rem;
  width: 100%;
  text-decoration: none;
  text-align: center;
  align-items: center;
  justify-content: center;
  &:hover {
    box-shadow: ${props => props.disabled ? 'none' : `0 0 5px var(--${props.color})`};
  }
`

export default class BackupScreeningPdfs extends Component {
  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <DashboardLayout
          title="Backup Screening PDFs"
          backHref="/resources"
          backText="Resources"
        >
          <Grid>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" target="_blank" href="/documents/screening-pdfs/jane-suspect/jane-suspect.pdf">Jane (Glaucoma Suspect)</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" target="_blank" href="/documents/screening-pdfs/john-open-angle/john-open-angle.pdf">John (Open Angle)</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" target="_blank" href="/documents/screening-pdfs/eleanor-angle-closure/eleanor-angle-closure.pdf">Eleanor (Angle-Closure)</PlaylistLink>
            </Grid.ThirdCell>
          </Grid>
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/BackupScreeningPdfs.js